import { useInjection } from "@linkfluence/core/di";
import {
  WorkspaceRepository,
  WorkspaceRepositoryUID,
} from "../repositories/WorkspaceRepository";

export function useWorkspaceRepository() {
  return useInjection<WorkspaceRepository>(WorkspaceRepositoryUID);
}
